// extracted by mini-css-extract-plugin
export default {"title":"Title_title__G2yGD","h2":"Title_h2__gjq9P"};